import { Injectable } from "@angular/core";
import { ApiService } from "../api.service";
import { Observable } from "rxjs";
import { IGenericKeyValue } from "../../models/exam/general.model";
import { toQueryString } from "../../helpers/query-string.helper";

@Injectable()
export class VideoCommentService {
  private apiPrefix = '/client/videos/';

  constructor(
    private api: ApiService,
  ) {
  }

  getPriorityComment(videoId: number, parentCommentId: number, subCommentId: number) {
    return this.api.get(`${this.apiPrefix}${videoId}/comments/${parentCommentId}/${subCommentId}`);
  }

  getComments(videoId: number, queryParams: IGenericKeyValue = {}): Observable<any> {
    let queryString = toQueryString(queryParams);
    queryString = (queryString ? `?` + queryString : '');
    return this.api.get(`${this.apiPrefix}${videoId}/comments${queryString}`);
  }

  getCommentAnswers(videoId: number, commentId: number, queryParams: IGenericKeyValue = {}) {
    let queryString = toQueryString(queryParams);
    queryString = (queryString ? `?` + queryString : '');
    return this.api.get(`${this.apiPrefix}${videoId}/comments/${commentId}/answers${queryString}`);
  }

  likeComment(videoId: number, commentId: number) {
    return this.api.patch(`${this.apiPrefix}${videoId}/comments/${commentId}/like`, {});
  }

  deleteLikeComment(videoId: number, commentId: number) {
    return this.api.delete(`${this.apiPrefix}${videoId}/comments/${commentId}/like`);
  }

  dislikeComment(videoId: number, commentId: number) {
    return this.api.patch(`${this.apiPrefix}${videoId}/comments/${commentId}/dislike`, {});
  }

  deleteDislikeComment(videoId: number, commentId: number) {
    return this.api.delete(`${this.apiPrefix}${videoId}/comments/${commentId}/dislike`);
  }

  sendComment(videoId: number, data: object) {
    return this.api.post(`${this.apiPrefix}${videoId}/comments`, data);
  }

  editComment(videoId: number, commentId: number, data: object) {
    return this.api.patch(`${this.apiPrefix}${videoId}/comments/${commentId}`, data);
  }

  deleteComment(videoId: number, commentId: number) {
    return this.api.delete(`${this.apiPrefix}${videoId}/comments/${commentId}`);
  }
}
